<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6" v-if="load_data">
    <badge-default class="my-2" :label="`Lotes: ${total_harvested_batches}`" />
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.week") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.registered_at") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.batch_code") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.crop_field") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.total_weight") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.discarded_weight") }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                v-for="(harvested_batch, index) in harvested_batches"
                :key="index"
                class="table-row"
              >
                <td class="table-cell">{{ harvested_batch.week }}</td>
                <td class="table-cell">
                  {{ dateFormatter(harvested_batch.registered_at) }}
                </td>
                <td class="table-cell">
                  <button
                    @click.prevent="showBatch(harvested_batch)"
                    class="link"
                  >
                    {{ harvested_batch.batch_code }}
                  </button>
                </td>
                <td class="table-cell">
                  {{ harvested_batch.crop_field?.name }}
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(harvested_batch.total_weight) }}
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(harvested_batch.discarded_weight) }}
                </td>
                <td class="table-cell">
                  <percent-bar
                    :ok_percent="harvested_batch.ok_percent"
                    :err_percent="harvested_batch.discarded_percent"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <table-paginator
      v-model="current_page"
      :total_rows="total_harvested_batches"
      :rows_per_page="rows_per_page"
    />
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_producers/show_producer.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import BadgeDefault from "@/components/views/layout/BadgeDefault.vue";
import PercentBar from "@/components/views/layout/PercentBar.vue";
export default {
  name: "PRODReportingProcessShowReportsDetails",
  components: {
    TablePaginator,
    BadgeDefault,
    PercentBar
  },
  props: {
    organization_id: { required: true },
    producer_id: { required: true },
    provider_type: { required: true },
    harvest_process_id: { required: true }
  },
  data() {
    return {
      load_data: false,
      current_page: 1,
      total_harvested_batches: 0,
      rows_per_page: 14,
      show_batch: false,
      harvested_batches: [],
      seriesM: [40, 30, 15, 10, 5]
    };
  },
  computed: {
    harvested_batches_with_percents() {
      return this.harvested_batches.filter(
        harvested_batch => harvested_batch.discarded_weight > 0
      );
    },
    discard_percent() {
      if (this.harvested_batch == null) return 0;
      return (
        (Number(this.harvested_batch.discarded_weight) /
          Number(this.harvested_batch.total_weight)) *
        100
      );
    }
  },
  created() {
    this.fetchTotalPages();
    this.fetchHarvestedBatches();
  },
  methods: {
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id,
        this.current_page - 1,
        this.rows_per_page
      );
      this.harvested_batches = response.data;
      this.fillPercentValues();
      this.load_data = true;
    },
    fetchTotalPages: async function () {
      let response = await Requester.fetchHarvestedBatchesTotal(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.total_harvested_batches = response.data;
      this.available_pages = Array.from(
        { length: Math.ceil(this.total_harvested_batches / this.rows_per_page) },
        (_, i) => i + 1
      );
    },
    fillPercentValues() {
      this.harvested_batches.forEach(harvested_batch => {
        const discarded_percent = this.discardPercent(harvested_batch);
        harvested_batch["discarded_percent"] = discarded_percent;
        harvested_batch["ok_percent"] = 100 - discarded_percent;
      });
    },
    discardPercent(harvested_batch) {
      let percent =
        (Number(harvested_batch.discarded_weight) /
          Number(harvested_batch.total_weight)) *
        100;
      return Math.round(percent);
    },
    showBatch(harvested_batch) {
      this.$router.push({
        name: this.routeName("show_harvested_batch"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id,
          producer_id: this.producer_id,
          provider_type: this.provider_type,
          harvested_batch_id: harvested_batch.id
        }
      });
    },
    harvestedPackages(harvested_batch) {
      return harvested_batch.harvested_packages.reduce((p, har_pkg) => {
        let name = har_pkg.crop_har_package.name;
        if (!Object.hasOwn(p, name)) p[name] = 0;
        p[name] += har_pkg.number;
        return p;
      }, {});
    },
  },
  watch: {
    current_page: function () {
      this.fetchHarvestedBatches();
    }
  }
};
</script>
